import React from 'react'
import styles from './styles.module.scss'

const HorizontalLine = ({className}) => <div className={[styles.line, className || ''].join(' ')} />

export default HorizontalLine
